import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { TABS } from '../../constants/tabs';

export default function TabBar({ title, tab, setTab, tabCounts }) {
  const theme = useTheme();
  // < md = มือถือ/แท็บเล็ตแนวตั้ง — แถบแท็บ 5 อันวางกึ่งกลางแบบ absolute จะล้นจอ เลยสลับเป็น
  // หัวข้อบรรทัดบน + แถวแท็บเลื่อนแนวนอนได้ด้านล่าง (ไม่ absolute, ไม่ยึดกึ่งกลาง)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const pills = (
    <Box
      sx={{
        display: 'flex',
        gap: 0.75,
        p: 0.75,
        borderRadius: '18px',
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        // เงาเดียวกับแถบแท็บของ /finance/expenses (ExpensesList.js)
        boxShadow: (thm) =>
          (thm.palette.mode === 'dark'
            ? '0 4px 20px rgba(0,0,0,0.35)'
            : '0 4px 20px rgba(15,23,42,0.06)'),
        ...(isMobile
          ? {
              width: '100%',
              overflowX: 'auto',
              flexWrap: 'nowrap',
              // ซ่อน scrollbar บนมือถือ ให้เลื่อนด้วยนิ้วเอา
              '&::-webkit-scrollbar': { display: 'none' },
              scrollbarWidth: 'none',
            }
          : { flexWrap: 'wrap', justifyContent: 'center' }),
      }}
    >
      {TABS.map((t) => {
        const selected = tab === t.key;
        const Icon = t.icon;
        return (
          <Box
            key={t.key}
            onClick={() => setTab(t.key)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? 0.5 : 0.9,
              px: isMobile ? 1.25 : 2,
              py: isMobile ? 0.75 : 1,
              borderRadius: '14px',
              cursor: 'pointer',
              userSelect: 'none',
              whiteSpace: 'nowrap',
              flexShrink: 0,
              transition:
                'transform 0.2s ease, background-color 0.2s ease, box-shadow 0.25s ease',
              transform: selected ? 'translateY(-1px)' : 'none',
              background: selected ? t.gradient : 'transparent',
              boxShadow: selected ? '0 6px 16px -4px rgba(0,0,0,0.35)' : 'none',
              '&:hover': {
                background: selected
                  ? t.gradient
                  : (thm) =>
                      (thm.palette.mode === 'dark'
                        ? 'rgba(255,255,255,0.06)'
                        : 'rgba(15,23,42,0.04)'),
              },
            }}
          >
            <Icon
              sx={{
                fontSize: isMobile ? 17 : 19,
                color: selected ? '#fff' : 'text.secondary',
              }}
            />
            <Typography
              sx={{
                fontSize: isMobile ? '0.78rem' : '0.85rem',
                fontWeight: selected ? 700 : 500,
                color: selected ? '#fff' : 'text.secondary',
              }}
            >
              {t.label}
            </Typography>
            {typeof tabCounts[t.key] === 'number' && (
              <Box
                sx={{
                  minWidth: 20,
                  height: 20,
                  px: 0.7,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '999px',
                  fontSize: '0.7rem',
                  fontWeight: 700,
                  lineHeight: 1,
                  bgcolor: selected
                    ? 'rgba(255,255,255,0.28)'
                    : (thm) =>
                        (thm.palette.mode === 'dark'
                          ? 'rgba(255,255,255,0.12)'
                          : 'rgba(15,23,42,0.07)'),
                  color: selected ? '#fff' : 'text.secondary',
                }}
              >
                {tabCounts[t.key]}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );

  return (
    // แถบแท็บกึ่งกลาง ไม่มีหัวข้อซ้ำ — เหมือน /finance/expenses (ชื่อหน้าอยู่ที่เมนู/แท็บเบราว์เซอร์แล้ว)
    <Box
      aria-label={title}
      sx={{
        flexShrink: 0,
        mb: 2,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {pills}
    </Box>
  );
}
